import { createPopper } from "@popperjs/core"

const LOGIN_BOX_ID = "login_box"
const LOGIN_BOX_VISIBLE_CLASSNAME = "modal-login-box--is-visible"
const TRIGGER_CLASSNAME = "js-login-trigger"
const CLOSE_CLASSNAME = "js-login-close"

function init() {
  const loginBox = document.getElementById(LOGIN_BOX_ID)
  if (!loginBox) return

  let popperInstance = null

  const close = loginBox.getElementsByClassName(CLOSE_CLASSNAME)[0]
  if (close) {
    close.addEventListener("click", () => {
      loginBox.classList.remove(LOGIN_BOX_VISIBLE_CLASSNAME)

      if (popperInstance) {
        popperInstance.destroy()
        popperInstance = null
      }
    })
  }

  const form = loginBox.querySelector("form")
  const buttons = Array.from(document.getElementsByClassName(TRIGGER_CLASSNAME))
  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault()

      if (loginBox.classList.contains(LOGIN_BOX_VISIBLE_CLASSNAME)) {
        loginBox.classList.remove(LOGIN_BOX_VISIBLE_CLASSNAME)

        if (popperInstance) {
          popperInstance.destroy()
          popperInstance = null
        }
      } else {
        loginBox.classList.add(LOGIN_BOX_VISIBLE_CLASSNAME)
        form.querySelector("input[type=text]").focus()
        popperInstance = createPopper(button, loginBox, {
          placement: "bottom-end",
        })
      }
    })
  })
}

export default init
